var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324,
    height: 511.447,
    viewBox: "0 0 324 511.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff9f9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    transform: "translate(-3902 -2672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M243-511.4c-20.5,2-45,9.9-63.1,20.5-29.7,17.3-47,46.7-47,79.9,0,6.3,2.7,43.8,6.1,83.3l6,71.8-2,24.2c-1.2,13.2-2.2,24.2-2.3,24.3s-8.5-3.1-18.7-7.2c-10.2-4-19.3-7.4-20.2-7.4s-3,1.2-4.7,2.6L94-216.8v15c0,8.9.5,16.7,1.2,19.1.7,2.2,3.3,6.2,5.8,8.9,4,4.4,6.1,5.6,20,11.2l15.5,6.3-.2,3.4c-.2,1.9-1,11.9-1.9,22.4a263.741,263.741,0,0,0-1.1,30,93.161,93.161,0,0,0,42.2,72.8c6.8,4.3,37.7,18.2,50,22.5,22.4,7.6,44.8,6.6,69.1-3.2,32.8-13.2,44.2-19.4,55.7-30.5a93.318,93.318,0,0,0,25.3-41.8c3.5-12.1,4.1-25.9,2-49.8-.9-10.5-1.7-20.5-1.9-22.4l-.2-3.4,15.5-6.3c13.9-5.6,16-6.8,20-11.2,2.5-2.7,5.1-6.7,5.8-8.9.7-2.4,1.2-10.2,1.2-19.1v-15l-3.1-2.6c-1.7-1.4-3.8-2.6-4.8-2.6-.9,0-10,3.3-20.1,7.4-10.2,4.1-18.6,7.3-18.7,7.2s-1.1-11-2.3-24.3l-2-24.1,6-72.3c3.4-39.8,6.1-77.4,6.1-83.4A91.193,91.193,0,0,0,345-482.1c-15.5-12.4-39.9-23-63-27.4C273.5-511.1,251.2-512.1,243-511.4Z",
    transform: "translate(3808 3183.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    className: "cls-1",
    d: "M237.8-444.5c-14.3,2.4-26.9,7.4-46.3,18.2-12.4,7-16.7,11.9-18.4,20.9-.8,4-.2,9.5,3.2,30.1l4.1,25.3H331.6l4.1-25.3c3.4-20.6,4-26.1,3.2-30.1-2-11-7.7-15.9-32.9-28.6C285.5-444.4,260.1-448.3,237.8-444.5Z",
    transform: "translate(3808 3183.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    className: "cls-1",
    d: "M180-247.2c0,.4-1.8,18.6-4.1,40.3-4.5,43.2-4.6,50.2-.8,56.9,6.2,11,34.3,25.2,58.4,29.5,11.8,2.1,33.2,2.1,45,0,17.4-3.1,37.4-11.5,50.4-21,7.6-5.6,11.1-12.3,11.1-20.9,0-3.4-1.8-23.9-4-45.6s-4-39.6-4-39.8C332-248.4,180-247.9,180-247.2Z",
    transform: "translate(3808 3183.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    className: "cls-1",
    d: "M178.3-110.6l-6.2,4.2,17.1,25.6,17,25.7,6.9-4.6a82.624,82.624,0,0,0,6.9-4.9c0-1.4-33.5-50.4-34.4-50.3C185-114.9,181.7-113,178.3-110.6Z",
    transform: "translate(3808 3183.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    className: "cls-1",
    d: "M308.7-90C299.5-76.3,292-64.8,292-64.5c0,.4,9.2,6.8,12.7,8.9.8.4,6.9-7.8,18.3-24.8l17-25.5-6-4.1c-3.3-2.2-6.6-4.3-7.3-4.6C325.8-114.9,319.7-106.5,308.7-90Z",
    transform: "translate(3808 3183.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    className: "cls-1",
    d: "M373.966-180.3l9.838-4c8.822-3.554,10.155-4.316,12.694-7.108a19.292,19.292,0,0,0,3.681-5.649c.444-1.523.762-6.474.762-12.122v-9.52l-1.967-1.65a6.919,6.919,0,0,0-3.046-1.65c-.571,0-6.347,2.094-12.757,4.7-6.474,2.6-11.8,4.633-11.868,4.57Z",
    transform: "translate(3814.7 3194.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    className: "cls-1",
    d: "M398.274-180.3l-9.838-4c-8.822-3.554-10.155-4.316-12.694-7.108a19.292,19.292,0,0,1-3.681-5.649c-.444-1.523-.762-6.474-.762-12.122v-9.52l1.967-1.65a6.919,6.919,0,0,1,3.046-1.65c.571,0,6.347,2.094,12.757,4.7,6.474,2.6,11.805,4.633,11.869,4.57Z",
    transform: "translate(3541.139 3194.627)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.4722b999.svg";
export { ForwardRef as ReactComponent };